import React from 'react'
import Link from 'next/link'
import { Button } from 'antd'
import { useWindowSize } from 'src/app/hooks'
import { useTranslation } from 'next-i18next'
import { EyeOutlined } from '@ant-design/icons'
import styles from './MyIntegrationActionColumn.module.scss'

export const MyIntegrationActionColumn: React.FC<{ intergation_id: number }> = (props) => {
  const { t } = useTranslation()
  const { isMobile } = useWindowSize()
  const link = `/developers/integration-details/?id=${props.intergation_id}`

  return <Link href={link} passHref>
    <Button
      icon={<EyeOutlined />}
      className={styles['action-button']}
      block={isMobile}
    >
      {t('developers.ViewIntegration')}
    </Button>
  </Link>
}

export default MyIntegrationActionColumn
